import { Component, OnInit } from '@angular/core';
import { ShipperEditFormComponent } from './shipper-edit-form/shipper-edit-form.component';
import { MatDialog, MatDialogRef } from '@angular/material';
import { DataTableComponent } from '../datatable/datatable.component';
import { AppService } from '../../services/app.service';
import { ShipperService } from '../../services/shipper.service';
import { Datatable } from '../../models/datatable.model';
import { SharedService } from '../../services/shared';

@Component({
  selector: 'app-shipper',
  templateUrl: './shipper.component.html',
  styleUrls: ['./shipper.component.scss']
})
export class ShipperComponent implements OnInit {
public data;
public length;
editFormDialogRef: MatDialogRef<ShipperEditFormComponent>;
translations: any;
pageIndex: Number = 0;
pageSize: Number = 10;
filterText: String = '';
sortDirection: String = 'asc';
sortHeaderName: String = 'Code';
sortColumnNameById: String = 'Id';

constructor(
private shipperService: ShipperService,
public appService: AppService,
private datatableComponent: DataTableComponent,
public dialog: MatDialog,
private datatableProp: Datatable,
private sharedService: SharedService
) {
    this.setPageTranslations();
    this.appService.showLoading();
    this.appService.checkSession();
    this.getShippers();
}

setPageTranslations(){
    this.translations = JSON.parse(sessionStorage.getItem('pageData')); 
}

ngOnInit() {
}

getShippers(): void {
    this.appService.showLoading();
 this.shipperService.all(this.pageIndex,this.pageSize,this.sortColumnNameById,this.sortDirection,this.filterText).subscribe(
   res => this.getAllShipperSuccess(res),
   error => this.apiFaillure(error)
 );
}

getAllShipperSuccess(res): void {
    this.data = [];
    if (res.Status == 1) {
        this.data = JSON.parse(res.Data).Table;
        this.datatableProp = this.appService.mapDataTableProp(this.datatableProp,JSON.parse(res.Data).Table1[0]);      
        this.datatableProp.gridControl = JSON.parse(res.Data).Table2;
        this.datatableProp.columnKeyData = JSON.parse(res.Data).Table3;
        this.length = this.data.length == 0 ? 0 : JSON.parse(res.Data).Table[0].MaxRowNumber;
        this.sharedService.Data.next(this.data);
        this.appService.hideLoading();
    } else if (res.Status == -1) {
        this.apiFaillure(res.Message);
    }
}
apiFaillure(error): void {
    this.appService.showDialogue(this.translations.hdError, this.translations[error]);
}

editRecord(e): void {
    this.editFormDialogRef = this.dialog.open(ShipperEditFormComponent, {
    disableClose: true,
    data: {
    Id: e.currentTarget.id
    },
    panelClass: 'my-dialog'
    });
    this.editFormDialogRef.afterClosed()
    .subscribe((response) => {
        this.appService.showLoading();
        this.data = '';
        this.getShippers();
    });
}

deleteRecord(e): void {
    var shipperId = e.currentTarget.id;
     this.appService.showDialogue(this.translations.hdConfirm, this.translations.confrimMessage,true)
    .afterClosed().subscribe(result => {
      if (result) {
        this.appService.showLoading();
        this.deleteConfirm(shipperId);
      }          
    });
  }
  
  deleteConfirm(shipperId){
     this.shipperService.delete(shipperId).subscribe(
      res => this.deleteSuccess(res),
      error => this.apiFaillure(error)
    );
  }
  
  deleteSuccess(res){
   if (res.Status == 1){
        this.appService.showDialogue(this.translations.hdSuccess, this.translations[res.Message])
        .afterClosed().subscribe(result => {
            if (result) {
            this.appService.hideLoading();
            this.data = '';
            this.getShippers();
            }          
        });        
    }
    else if (res.Status == -1) {
        this.apiFaillure(res.Message);
    }
  }

addRecord(): void {
    this.editFormDialogRef = this.dialog.open(ShipperEditFormComponent, {
    disableClose: true,
    data: {
    Id: 0
    },
    panelClass: 'my-dialog'
    });
    this.editFormDialogRef.afterClosed()
    .subscribe((response) => {
    this.appService.showLoading();
    this.data = '';
    this.getShippers();
    });
 }
 getServerData(event){
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.getShippers();
 }
 applyFilter(filterValue: any){
    this.filterText = filterValue;
    this.getShippers();
 }
 getSortedData(event){
    this.sortColumnNameById = event.currentTarget.getAttribute('id');
    this.getShippers();
 }
}



// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/shipper/shipper.component.ts